import Breadcrumb from '../Component/Breadcrumb'
const About = () => {
    return (
        <>
            <Breadcrumb breadtitle="Our History" breadmid="About" breadend="History" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='maintitle'>Introduction About Canossa School</h2>
                            <p><span>The Canossian Daughters of Charity is Religious Institute founded by St. Magdalene of Canossa in 1808 at Verona, Italy.</span></p>
                            <p>Saint Magdalene of Canossa was born in 1774 in an aristocratic family of Verona. She grew up at a time when corowuption, abuse and social injustice were rampant in Italy and other parts of Europe. The situation was worsened by the Napoleonic Wars and the invasion of foreign powers in Italy.</p>
                            <p>Inspired by her love of God and deeply empathetic towards the suffering of the poor, Magdalene gave up the luxury and security of her palace, to establish institutions for the needy, the sick and suffering. The institute of the Canossian Daughters of Charity is Present in thirty-three countries throughout the world. Our Sisters first came to India in 1889. Today we have 75 branches in India, dedicated to education, medical services and social uplift of the poorer sections of society. The education of the girl-child and the empowerment of women are our special concerns.</p>
                            
                        </div>
                    </div>
                </div>
                <img src="https://webapi.entab.info/api/image/CSFL/public/images/about.jpg" className="img-fluid" />
            </div>
        </>
    )
}
export default About